
import Vue from 'vue'
import { CheckoutPageModel } from '@ViewModels/CheckoutPageModel'

export default Vue.extend({
   name: 'DigitalDelivery',
   data() {
      return {
         selectedAddressId: 'new',
      }
   },
   computed: {
      modelData(): CheckoutPageModel {
         return this.$store.state.modelData
      },
      hasDigitalProducts(): boolean {
         return this.modelData.HasDigitalProducts
      },
      hasVitalSourceProducts(): boolean {
         return this.modelData.HasVitalSourceProducts
      },
   },
   components: {},
})
